import React from "react";
import { Header } from '../../../Components/Layout/Header.jsx';
import { ObavijestiCasino } from '../../../Components/Layout/ObavijestiCasino.jsx';
import { MetaTags } from '../../../Components/Layout/MetaTags.jsx';

export class OpcaPravila extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            textHTML: null,
            loading: true,
            generalRulesCategories: [
                {
                    id: 1,
                    title: 'Hrvatski',
                },
                {
                    id: 2,
                    title: 'Engleski',
                },
                {
                    id: 3,
                    title: 'Njemački',
                },
            ],
            subMenu: [
                [
                    {
                        title: 'Opća pravila',
                        file: 'Opca.html'
                    },
                    {
                        title: 'Pravila igara na automatima',
                        file: 'Automati.html'
                    },
                    {
                        title: 'Pravila igara na stolovima',
                        file: 'Stolovi.html'
                    },
                    {
                        title: 'Pravila pokera',
                        file: 'Poker.html'
                    },
                    {
                        title: 'Pravila klađenja',
                        file: 'SuperSportPravilaIgre.html'
                    }
                ],
                [
                    {
                        title: 'General rules',
                        file: 'General.html'
                    },
                    {
                        title: 'Rules of slot games',
                        file: 'Slot.html'
                    },
                    {
                        title: 'Rules of table games',
                        file: 'Table.html'
                    },
                    {
                        title: 'Rules of poker game',
                        file: 'Poker.html'
                    },
                    //{
                    //    title: 'Rules of betting',
                    //    file: ''
                    //}
                ],
                [
                    {
                        title: 'Allgemeinen Bedingungen',
                        file: 'Allgemeinen.html'
                    },
                    {
                        title: 'Bedinungen für Spielautomaten',
                        file: 'Automaten.html'
                    },
                    {
                        title: 'Bedinungen für Tischspielen',
                        file: 'Tischen.html'
                    },
                    {
                        title: 'Bedinungen für Poker',
                        file: 'Poker.html'
                    },
                    //{
                    //    title: 'Wett bedinungen',
                    //    file: ''
                    //}
                ]
            ],
            subMenuActiveIndex: 0,
            subMenuIsActive: false,
            generalRulesActiveIndex: 1,
            showInformacije: false
        }
    }

    /**** LIFECYCLE METHODS *****/
    componentDidMount() {
        casino.repos.casinoDocumentsRepo.get('opcapravila/pravilaigre/Opca.html').then((dataHTML) => {
            this.setState({
                loading: false,
                textHTML: dataHTML
            });
        });

        const group = this.state.subMenu[this.state.generalRulesActiveIndex-1];

        if (group && window.location.href.includes("pravila/opca-pravila?vrsta=")) {
            // Mapiranje parametra iz URL-a na naziv datoteke
            const fileMapping = {
                'poker': 'Poker.html',
                'stolovi': 'Stolovi.html',
                'automati': 'Automati.html',
                'kladenje': 'SuperSportPravilaIgre.html'
            };

            // Izvlačenje vrijednosti "vrsta" iz URL-a
            const urlParams = new URLSearchParams(window.location.search);
            const vrsta = urlParams.get('vrsta');

            // Provjera postoji li datoteka za tu vrstu u našem mapiranju
            const targetFile = fileMapping[vrsta];

            if (targetFile) {
                const itemIndex = group.findIndex(item => item.file === targetFile);

                if (itemIndex !== -1) {
                    this.setState({ subMenuActiveIndex: itemIndex });
                }
            }
        }
    }

    menuClick(index) {
        let language = index == 2 ? 'en/' : index == 3 ? 'de/' : '';

        this.setState({ loading: true });

        casino.repos.casinoDocumentsRepo.get('opcapravila/pravilaigre/' + language + this.state.subMenu[index - 1][this.state.subMenuActiveIndex].file).then((dataHTML) => {
            this.setState({
                loading: false,
                textHTML: dataHTML,
                generalRulesActiveIndex: index,
                subMenuIsActive: false
            });
        });
    }

    opcaPravilaShowHide(index) {
        this.setState({ subMenuIsActive: !this.state.subMenuIsActive });
    }

    renderNavItem(item, index) {
        return (
            <li key={"nav-" + index} className={"nav-item " + (item.id == this.state.generalRulesActiveIndex ? 'active' : '')} onClick={() => this.menuClick((item.id))}>
                <a>{item.title}</a>
                <div key={"select-" + index} className={"select-item " + (item.id == this.state.generalRulesActiveIndex ? 'active' : '')}>
                </div>
            </li>
        )
    }

    subMenuOnClick(index) {
        this.setState({ loading: true });

        let language = this.state.generalRulesActiveIndex == 2 ? 'en/' : this.state.generalRulesActiveIndex == 3 ? 'de/' : '';

        casino.repos.casinoDocumentsRepo.get('opcapravila/pravilaigre/' + language + this.state.subMenu[this.state.generalRulesActiveIndex - 1][this.state.subMenuActiveIndex].file).then((dataHTML) => {
            this.setState({
                loading: false,
                textHTML: dataHTML,
                subMenuActiveIndex: index,
                subMenuIsActive: false
            });
        });
    }

    renderIzbornik(item, index) {
        return (
            <div key={"op-" + index} className={"op-menu " + (this.state.subMenuIsActive ? 'active' : '')}>
                <div className="main-menu" onClick={() => this.opcaPravilaShowHide()}>
                    <p>{this.state.subMenu[this.state.generalRulesActiveIndex - 1][this.state.subMenuActiveIndex].title}</p>
                    <button className="burger"></button>
                </div>
                <div className="sub-menu">
                    <ul className="sub-menu-items">
                        {this.state.subMenu[this.state.generalRulesActiveIndex - 1].map((item, index) => {
                            return (
                                <li key={"sub-" + index} className={"sub-menu-item " + (this.state.subMenuActiveIndex == index ? 'selected' : '')} onClick={() => this.subMenuOnClick(index)}>
                                    <p>{item.title}</p>
                                    {this.state.subMenuActiveIndex == index && <div className="arrow"></div>}
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        )
    }

    render() {
        return <div>
            <MetaTags title="Opca pravila | SuperSport Online Casino | SuperCasino" description="Opca pravila igara na sreću. SuperSport Casino." />
            <Header key="header" {...this.state} {...this.props}></Header>

            {!this.state.showInformacije &&
                <>
                    <ul className="op-nav">
                        {this.state.generalRulesCategories.map((item, index) => {
                            return this.renderNavItem(item, index)
                        })}
                    </ul>
                    <div className="content-container">
                        {this.renderIzbornik()}
                    </div>
                </>
            }

            <div id="page-wrapper" className="white padding-2p-on-mobile border-on-tablet margin-1p-on-tablet">
                <div className="padding-sides-medium margin-center">
                    <div className="pravila-text-container">
                        {this.state.loading && <p>Učitavam sadržaj...</p>}
                        {!this.state.loading && this.state.textHTML && <div dangerouslySetInnerHTML={{ __html: this.state.textHTML }} />}
                    </div>
                </div>

            </div>

            <ObavijestiCasino {...this.props}></ObavijestiCasino>

        </div>
    }
};
